// Libs
import { Link } from "react-router-dom";

// Types
type TFooterComponentProps = {
    footerRoutesArr: any
}

/**
 * Reusable component, intended to be used as footer in multiple layouts.
 * @param {any} footerRoutesArr an object with string parameters `path` and `label`
 * @returns
 */
const FooterComponent = ({ footerRoutesArr }: TFooterComponentProps) => {
    return (
        <footer className="it-footer">
            <div className="it-footer-main">
                <div className="container">
                    <ul className="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row py-4 justify-content-center">
                        {/* <li key="default-link" className="list-inline-item footer-link-pec">
                            PEC: info@pec.portaletrasporto.it
                        </li> */}
                        {footerRoutesArr.map((route: any, idx: number) => (
                            <li key={idx} className="px-3 mr-1 list-inline-item">
                                <Link
                                    className="text-decoration-none text-white"
                                    to={route.path}
                                >
                                    {route.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default FooterComponent;
